/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import IconRoundButton from "../../../../components/_utils/CommonButtons/IconRoundButton";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import Loader from "../../../../components/Loader/Index";
import BeneficiaryTransactionGridView from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionGridView/index.jsx";
import BeneficiaryTransactionListView from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionListView/index.jsx";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { getAllBeneficiaryAccounts } from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources";
import {
  beneficiaryTransactionsActionable,
  beneficiaryTransactionsAddLabel,
  beneficiaryTransactionsRemoveLabel,
  beneficiaryTransactionsViewAll,
  resetToggle,
  setToggle,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import useMultiSelect from "../../../../utils/useMultiSelect";

const BeneficiaryTransactionViewall = (props) => {
  const services = useSelector((state) => state.refreshToken.services);
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const isPopupMode =
    props?.typepop === "transactionHistorypopup" ||
    props?.typepop === "RejectAllTransactionPopup" ||
    props?.typepop === "BeneAccRejectTxn" ||
    props?.typepop === "txnHistorypopup" ||
    props?.similarTxnType === "similarTxn";

  const defaults = {
    ...(location?.state?.approvalStatus && !isPopupMode
      ? { lifecycle: location.state.approvalStatus }
      : {}),
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  };

  const {
    searchParam: urlSearchParam,
    handleSearchParams: urlHandleSearchParams,
    handleClearSearchParam: urlHandleClearSearchParam,
  } = useCustomSearchParams(defaults);

  const searchParam = isPopupMode
    ? new URLSearchParams(defaults)
    : urlSearchParam;

  const handleSearchParams = isPopupMode ? () => {} : urlHandleSearchParams;

  const handleClearSearchParam = isPopupMode
    ? () => {}
    : urlHandleClearSearchParam;

  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  const [inputData, setInputData] = useState([]);
  const {
    approvalStatus,
    DistributionDashBoard,
    startDateLocationState,
    endDateLocationState,
  } = location.state || {};

  const [DashBoardStatus, SetDashBoardStatus] = useState(approvalStatus);

  const category =
    props?.typepop === "transactionHistorypopup" ||
    props?.typepop === "txnHistorypopup"
      ? props?.category
      : location.state
        ? location.state.category
        : "";

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    props?.typepop === "RejectAllTransactionPopup" ||
      props?.typepop === "BeneAccRejectTxn"
      ? "pending"
      : location?.state
        ? location?.state?.approvalStatus
        : searchParam.get("lifecycle") || "",
  );

  const [isSidebarOpen] = useState(false);

  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(
    startDateLocationState
      ? startDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    endDateLocationState
      ? endDateLocationState
      : convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );

  const [isPaymentMethod, setIsPaymentMethod] = useState(
    searchParam.get("paymentmethod") ||
      ((props?.similarTxnType === "similarTxn" ||
        props?.typePopup !== "BeneAccRejectTxn") &&
        props?.queryParams?.payment_method) ||
      "",
  );
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [txnAddDetails, setTxnAddDetails] = useState(
    searchParam.get("search") || "",
  );
  const [txnAmountFilter, setTxnAmountFilter] = useState(
    props?.similarTxnType === "similarTxn"
      ? props?.queryParams?.amount
      : searchParam.get("amount") || "",
  );
  const [mainData, setMainData] = useState([]);
  const [selectedBeneAccId, setSelectedBeneAccId] = useState(
    props?.similarTxnType === "similarTxn" &&
      props?.queryParams?.beneficiary_account_id
      ? props?.queryParams?.beneficiary_account_id
      : props?.bene_account_id
        ? props?.bene_account_id
        : searchParam.get("beneAcc") || "",
  );
  const [selectedOwnerAccId, setSelectedOwnerAccId] = useState(
    props?.Owner_account_id ||
      (props?.similarTxnType === "similarTxn"
        ? props?.queryParams?.owner_account_id
        : "") ||
      (props?.typePopup !== "BeneAccRejectTxn"
        ? searchParam.get("sourceAcc")
        : "") ||
      "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.bene_account_id ? props?.bene_account_id : null,
  );
  const [currentCategory, setCurrentCategory] = useState(
    category ? category?.category_id : searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    category ? category?.category_name : searchParam.get("dispCategory") || "",
  );
  const [accountName, setAccountName] = useState(
    props?.bene_account_name
      ? props?.bene_account_name
      : searchParam.get("beneAccName") || "",
  );
  const [accountNameValue, setAccountNameValue] = useState("");

  const [isOpen, setIsOpen] = useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentStatusDistribution, setCurrentStatusDistribution] = useState(
    searchParam.get("distribution") || "",
  );

  const [accountNumber, setAccountNumber] = useState(
    props?.Owner_account_number
      ? props?.Owner_account_number
      : searchParam.get("sourceAccName") || "",
  );
  const [totalBalanceAmount, setTotalBalanceAmount] = useState(0);

  const [isConfidentialMethod, setIsConfidentialMethod] = useState(
    props?.bene_account_confidential === "Y"
      ? "Show only confidential" ||
          (props?.similarTxnType === "similarTxn" &&
            props?.queryParams?.confidential_transaction ===
              "Show only confidential")
      : props?.bene_account_confidential === "N" ||
          (props?.similarTxnType === "similarTxn" &&
            props?.queryParams?.confidential_transaction ===
              "Hide confidential")
        ? "Hide confidential"
        : searchParam.get("confidential") || "",
  );
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelTransactions, setLabelTransactions] = useState([]);
  const [labelsFilter, setFilterLabels] = useState(
    searchParam.get("label")?.split(",") || [],
  );

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const labelActionDispatchedRef = useRef(false);

  const selectedCount = labelTransactions.length;

  const selectableTransactions = accumulatedData
    ?.filter((item) => item?.approval_status !== "archived")
    ?.map((item) => ({ ...item, id: item?.txn_id }));
  const totalRecordCount = Number(mainData?.total_count || 0);

  const effectiveSelectCap =
    totalRecordCount > 0 && totalRecordCount <= Number(selectedValue)
      ? totalRecordCount
      : Number(selectedValue);

  const isAllSelected =
    labelTransactions?.length === effectiveSelectCap && effectiveSelectCap > 0;

  const handleSelectAll = () => {
    handleMultiSelectAll(
      labelTransactions,
      setLabelTransactions,
      selectedValue,
      selectableTransactions,
    );
  };

  const handleLabelTransactionSelect = (transaction) => {
    handleSingleSelect(labelTransactions, setLabelTransactions, selectedValue, {
      ...transaction,
      id: transaction?.txn_id,
    });
  };

  const handleCloseTxn = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      handleAction();
      setLabelTransactions([]);
      setisLabelClicked(false);
    }
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const isConfPopup = (props?.popup ?? "") === "Confidential transaction";

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const filterRef = useRef(null);

  const dispatch = useDispatch();
  const { toggle } = useSelector((state) => state.beneficiaryTransactions);

  const handleStatus = (status) => {
    handleClose1();

    if (status === "require approval") {
      setIsPaymentMethod("");
      setStartDateFilter("");
      setEndDateFilter("");
      handleSubmit("paymentmethod", "");
      handleSubmit("date", "");
    }

    getAccStatus(status, "status");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.id,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Labels":
          data =
            labels
              ?.filter((itm) => itm.includes(searchUserTextDebounce))
              ?.map((val) => ({ id: val, Label: val })) || [];
          break;

        case "Beneficiary account":
          response = await dispatch(
            getAllBeneficiaryAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.beneficiary_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          break;
        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  const handleStatus1 = (status) => {
    handleClose();

    let statusToSend;

    switch (status) {
      case "distribution complete":
        statusToSend = "distribution_complete";
        break;
      case "distribution created":
        statusToSend = "created";
        break;
      case "distribution initiated":
        statusToSend = "distribution_initiated";
        break;
      case "distribution approved":
        statusToSend = "approved";
        break;
      case "distribution pending":
        statusToSend = "distribution_pending";
        break;
      case "awaiting funds":
        statusToSend = "awaiting_funds";
        break;
      case "distribution reversal":
        statusToSend = "reversal";
        break;
      case "distribution denied":
        statusToSend = "denied";
        break;
      case "distribution rejected":
        statusToSend = "rejected";
        break;
      case "distribution failed":
        statusToSend = "failed";
        break;
      case "distribution abandoned":
        statusToSend = "abandoned";
        break;
      default:
        statusToSend = status;
        break;
    }

    getAccStatus(statusToSend, "distribution");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const getDisplayDistributionStatus = (status = "") => {
    switch (status) {
      case "distribution_complete":
        return "distribution complete";
      case "created":
        return "distribution created";
      case "distribution_initiated":
        return "distribution initiated";
      case "approved":
        return "distribution approved";
      case "distribution_pending":
        return "distribution pending";
      case "awaiting_funds":
        return "awaiting funds";
      case "reversal":
        return "distribution reversal";
      case "denied":
        return "distribution denied";
      case "rejected":
        return "distribution rejected";
      case "failed":
        return "distribution failed";
      case "abandoned":
        return "distribution abandoned";
      default:
        return status || "";
    }
  };

  const handleClose = () => {
    SetDashBoardStatus("all");
    setIsOpen(false);
  };

  const handleClose1 = () => {
    SetDashBoardStatus("all");
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      labelTransactions?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(
        labelTransactions,
        setLabelTransactions,
        value,
        labelTransactions,
      );
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      dispatch(setToggle(newToggleValue));
    }
  };

  const scrollContainerRef = useRef(null);
  const navStateAppliedRef = useRef(false);
  useEffect(() => {
    if (location.state?.DistributionDashBoard) {
      setCurrentStatus("all");
      setCurrentStatusDistribution(
        location.state?.distribution_lifecycle_status || "all",
      );
    }
  }, [
    location.state?.DistributionDashBoard,
    location.state?.distribution_lifecycle_status,
  ]);

  const handleAction = async () => {
    if (searchUserTextDebounce !== "") {
      setMainData([]);
    }
    if (currentStatus === "require approval") {
      try {
        setLoading(true);

        const responseApproval = await dispatch(
          beneficiaryTransactionsActionable({
            page_no: currentPage,
            page_item_count: pageSize,
            category_id: currentCategory,
            owner_account_id: selectedOwnerAccId
              ? selectedOwnerAccId
              : undefined,
          }),
        );

        const newApprovalData = responseApproval?.payload?.transactions || [];

        setMainData(responseApproval?.payload);
        setAccumulatedData(newApprovalData);
        setLoading(false);
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let queryParams = {
          page_no: currentPage,
          page_item_count: pageSize,
        };
        const addParamsBasedOnSelection = () => {
          if (
            currentStatusDistribution &&
            currentStatusDistribution !== "all"
          ) {
            if (currentStatusDistribution === "complete") {
              queryParams.distribution_lifecycle_status =
                "distribution_complete";
            } else if (currentStatusDistribution === "initiated") {
              queryParams.distribution_lifecycle_status =
                "distribution_initiated";
            } else if (currentStatusDistribution === "pending") {
              queryParams.distribution_lifecycle_status =
                "distribution_pending";
            } else {
              queryParams.distribution_lifecycle_status =
                currentStatusDistribution;
            }
          }

          if (
            DistributionDashBoard === false &&
            DashBoardStatus !== "all" &&
            DashBoardStatus !== "confidential"
          ) {
            queryParams.lifecycle_status = DashBoardStatus;
          }
          if (currentStatus && currentStatus !== "all") {
            queryParams.lifecycle_status = currentStatus;
          }

          if (currentCategory && currentCategory !== "Select category") {
            queryParams.category_id = currentCategory;
          }
          if (
            startDateFilter &&
            endDateFilter &&
            !isNaN(Number(startDateFilter)) &&
            !isNaN(Number(endDateFilter))
          ) {
            if (navStateAppliedRef.current) {
              queryParams.start_date = startDateFilter;
              queryParams.end_date = endDateFilter;
            } else {
              queryParams.start_date = startDateFilter + 86400;
              queryParams.end_date = endDateFilter + 86400;
            }
          }

          if (isPaymentMethod) {
            queryParams.payment_method = isPaymentMethod;
          }
          if (isConfidentialMethod) {
            queryParams.confidential_transaction = isConfidentialMethod;
          }

          if (txnAddDetails !== "") {
            queryParams.additional_data = txnAddDetails;
          }

          if (txnAmountFilter !== "") {
            queryParams.amount = txnAmountFilter;
          }
          if (selectedBeneAccId !== "") {
            queryParams.beneficiary_account_id = selectedBeneAccId;
          }
          if (selectedOwnerAccId !== "") {
            queryParams.owner_account_id = selectedOwnerAccId;
          }
          if (labelsFilter?.length && labelsFilter !== "Select labels") {
            queryParams.labels = labelsFilter;
          }
        };
        addParamsBasedOnSelection();

        const response = await dispatch(
          beneficiaryTransactionsViewAll(queryParams),
        );
        const newData = response?.payload?.transactions || [];
        setMainData(response?.payload);
        setAccumulatedData(newData);
        setTotalBalanceAmount(Number(response?.payload?.total_amount || 0));
        setLoading(false);
        if (props?.typepop === "RejectAllTransactionPopup") {
          props?.setShowLoader(false);
        }
      } catch (error) {
        setAccumulatedData([]);
        setMainData([]);
        setLoading(false);
      }
    }
  };

  const onMount = () => {
    dispatch(resetToggle());
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) dispatch(disableSwitcher());
    else dispatch(enableSwitcher());
  }, [isLabelClicked]);

  useEffect(() => {
    if (filterRef.current) {
      filterRef.current.scrollTo({ top: GlobalConfiguration?.lengthCheckZero });
    }
  }, [toggle, currentPage, accumulatedData]);

  // const getAccStatus = (item, ele) => {
  //   if (ele === "distribution") {
  //     setCurrentStatusDistribution(item);
  //     setIsDistributionSelected(item !== "all");
  //     setIsStatusSelected(false);
  //   } else if (ele === "status") {
  //     if (props?.typepop !== "RejectAllTransactionPopup") {
  //       setCurrentStatus(item);
  //     }

  //     setIsDistributionSelected(false);
  //     setIsStatusSelected(item !== "all");
  //     setCurrentStatus(item);
  //   }
  // };

  const getAccStatus = (item, type) => {
    if (type === "distribution") {
      // If user is changing status manually, clear nav-state dates
      if (navStateAppliedRef.current) {
        setStartDateFilter("");
        setEndDateFilter("");
        navStateAppliedRef.current = false; // reset so future nav state changes are ignored
      }
      handleSubmit("distribution", item);
      setCurrentStatusDistribution(item);
      if (props?.typepop !== "BeneAccRejectTxn") setCurrentStatus("");
    } else if (type === "status") {
      handleSubmit("lifecycle", item);
      setCurrentStatus(item);
    }
  };

  useEffect(() => {
    // Apply navigation state only once
    if (location.state?.DistributionDashBoard && !navStateAppliedRef.current) {
      setCurrentStatus("all");
      setCurrentStatusDistribution(
        location.state.distribution_lifecycle_status || "all",
      );
      setStartDateFilter(location.state.startDateLocationState || "");
      setEndDateFilter(location.state.endDateLocationState || "");

      navStateAppliedRef.current = true;
      return;
    }
    handleAction();

    let availableLabels = sessionStorage?.getItem("beneficiaryTxnLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [
    markerData,
    currentPage,
    currentStatus,
    currentStatusDistribution,
    currentCategory,
    startDateFilter,
    endDateFilter,
    pageSize,
    isPaymentMethod,
    txnAddDetails,
    txnAmountFilter,
    selectedBeneAccId,
    selectedOwnerAccId,
    toggle,
    isConfidentialMethod,
    labelsFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    isPaymentMethod,
    selectedBeneAccId,
    selectedOwnerAccId,
    isConfidentialMethod,
    labelsFilter,
  ]);

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        !!isPaymentMethod ||
        isConfidentialMethod,
    );
  };

  const handleFilterDateRange = (date) => {
    if (!date || !date[0] || !date[1]) {
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = date;

    setStartDateFilter(convertDate(start));
    setEndDateFilter(convertDate(end));
  };
  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedConfidential) => {
    setIsConfidentialMethod(selectedConfidential);
  };

  const approvalDetails =
    currentStatus === "denied" ||
    currentStatus === "deleted" ||
    currentStatus === "approved" ||
    currentStatus === "rejected" ||
    currentStatus === "require approval" ||
    currentStatus === "pending" ||
    currentStatus === "abandoned";

  const distbuDetails =
    currentStatusDistribution === "created" ||
    currentStatusDistribution === "reversal" ||
    currentStatusDistribution === "approved" ||
    currentStatusDistribution === "denied" ||
    currentStatusDistribution === "rejected" ||
    currentStatusDistribution === "failed" ||
    currentStatusDistribution === "abandoned" ||
    currentStatusDistribution === "distribution_complete" ||
    currentStatusDistribution === "distribution_initiated" ||
    currentStatusDistribution === "distribution_pending" ||
    currentStatusDistribution === "awaiting_funds";

  const clearParameterVisibility = !!(
    txnAddDetails ||
    distbuDetails ||
    approvalDetails ||
    !!currentCategory ||
    !!(startDateFilter && endDateFilter) ||
    !!isPaymentMethod ||
    (!(
      props?.type === "bene_account_detail_modal" ||
      ((props?.typepop === "txnHistorypopup" ||
        props?.similarTxnType === "similarTxn") &&
        !!props?.bene_account_id)
    ) &&
      !!selectedBeneAccId) ||
    txnAmountFilter ||
    (!(
      props?.OwnerDetail &&
      !!props?.Owner_account_id &&
      props?.typepop === "txnHistorypopup"
    ) &&
      !!selectedOwnerAccId) ||
    isConfidentialMethod ||
    (!labelsFilter?.length ? false : true) ||
    accumulatedData.length
  );
  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleClearParams = (e) => {
    handleClearSearchParam();
    setShowSearchBar(false);
    getAccStatus(null, "distribution");
    SetDashBoardStatus("all");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    e?.stopPropagation();
    setTxnAddDetails("");
    setSearchUserTextDebounce("");
    setFilterLabels([]);
    setStartDateFilter("");
    setEndDateFilter("");
    handleClearSearchParam();

    if (props?.typepop === "txnHistorypopup") {
      setIsPaymentMethod("");
      setTxnAmountFilter("");
      if (!props?.OwnerDetail && props?.similarTxnType !== "similarTxn") {
        setSelectedOwnerAccId("");
      }

      if (props?.label?.label === "accountName") {
        setSelectedBeneAccId(props?.bene_account_id || "");
        setBeneAccountId(props?.bene_account_id || null);
        setAccountName(props?.bene_account_name || "");
        setAccountNameValue(props?.bene_account_name || "");
        setCurrentCategory("");
      } else if (props?.label?.label === "categoryName") {
        setCurrentCategory(props?.category || "");
        setSelectedBeneAccId(props?.bene_account_id || "");
        setBeneAccountId(props?.bene_account_id || null);
        setAccountName(props?.bene_account_name || "");
        setAccountNameValue(props?.bene_account_name || "");
      } else {
        setCurrentCategory("");
      }
      return;
    }

    if (props?.similarTxnType !== "similarTxn") {
      setIsPaymentMethod("");
      setTxnAmountFilter("");
    }
    if (
      props?.typepop === "RejectAllTransactionPopup" ||
      props?.typepop === "BeneAccRejectTxn"
    ) {
      setCurrentCategory("");
    }
    if (
      (props?.typepop !== "transactionHistorypopup" &&
        props?.typepop !== "RejectAllTransactionPopup" &&
        props?.typepop !== "txnHistorypopup" &&
        props?.similarTxnType !== "similarTxn" &&
        props?.typepop !== "BeneAccRejectTxn") ||
      props?.OwnerDetail
    ) {
      setBeneAccountId(null);
      setSelectedBeneAccId("");
      setAccountName("");
      setCurrentCategory("");
    }
    if (
      props?.typepop === "transactionHistorypopup" ||
      (props?.similarTxnType === "similarTxn" &&
        props?.label !== "categoryName")
    ) {
      setBeneAccountId(beneAccountId);
      setAccountName(accountName);
      setCurrentCategory("");
    } else if (
      props?.typepop === "transactionHistorypopup" &&
      props?.label === "categoryName"
    ) {
      setBeneAccountId("");
      setAccountName("");
      setSelectedBeneAccId("");
    }
    if (!props?.OwnerDetail && props?.similarTxnType !== "similarTxn") {
      setSelectedOwnerAccId("");
    }
    if (!isConfPopup) {
      setIsConfidentialMethod("");
    }
    handleClearSearchParam();
  };

  const handleSubmit = (key, value) => {
    if (
      props?.typepop !== "transactionHistorypopup" &&
      props?.typepop !== "RejectAllTransactionPopup" &&
      props?.typepop !== "BeneAccRejectTxn" &&
      props?.typepop !== "txnHistorypopup" &&
      props?.similarTxnType !== "similarTxn"
    ) {
      handleSearchParams(key, value);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload?.response?.data?.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      beneficiaryTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      setLabels((prev) =>
        Array.from(new Set([...(prev || []), ...(labelsToAssign || [])])),
      );

      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (beneficiaryTransactionsAddLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLoading(false);
    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTransactions)
      ?.map((item) => item?.id || item)
      ?.filter(Boolean);

    const res = await dispatch(
      beneficiaryTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (beneficiaryTransactionsRemoveLabel.fulfilled.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      await handleAction();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (beneficiaryTransactionsRemoveLabel?.rejected?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalExtraLarge);
    }

    setLoading(false);
    if (beneficiaryTransactionsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      <div
        className={`bg-primary-bg flex flex-col ${props?.typepop === "BeneAccRejectTxn" && "relative h-full"} relative ${
          props?.typepop === "transactionHistorypopup" ||
          props?.typepop === "RejectAllTransactionPopup"
            ? "h-full-height"
            : toggle &&
                !accumulatedData?.length &&
                showSearchBar &&
                isFilterApplied &&
                isLabelClicked
              ? "h-full-height"
              : props?.typepop === "txnHistorypopup" ||
                  props?.similarTxnType === "similarTxn"
                ? "h-full"
                : ""
        } webview`}
      >
        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
          !loading && (
            <div
              className={`absolute w-full h-pagination-height bottom-bottom-base ${isSidebarOpen || showInnerSearchBar || isOpen ? "z-z-index-content pointer-events-none" : "z-z-index-dropdown"} ${
                props?.typepop === "transactionHistorypopup" ||
                props?.typepop === "RejectAllTransactionPopup"
                  ? "bottom-bottom-base w-full rounded-none Qmd:bottom-0 Qmd:w-[96%] Qmd:rounded-b-border-radius-md"
                  : "bottom-bottom-base w-full rounded-none"
              } ${
                props?.typepop === "RejectAllTransactionPopup"
                  ? "h-auto Qmd:h-status_all_height"
                  : "h-pagination-height"
              }`}
            >
              <div
                className={`${
                  !accumulatedData.length &&
                  props?.typepop === "RejectAllTransactionPopup"
                    ? "hidden Qmd:block"
                    : `block ${showInnerSearchBar && `pointer-events-none`}`
                }`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  typepop={props?.typepop}
                  flowType={props?.flowType}
                  accountFlow={"Beneficiary"}
                  handleRejectAllTransaction={props?.handleRejectAllTransaction}
                  type={"alertAssociated"}
                  setIsOpen={setIsOpen}
                  typePopup={props?.typepop === "popup"}
                />
              </div>
            </div>
          )}

        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated transactions."
              closehandleFunction={handleCloseTxn}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={labelTransactions}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={labelTransactions}
              onClose={handleCloseTxn}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
            />
          </div>
        )}

        <div
          className={`bg-primary-bg flex flex-col ${
            props?.typepop === "transactionHistorypopup" ||
            props?.typepop === "RejectAllTransactionPopup" ||
            props?.typepop === "BeneAccRejectTxn"
              ? "h-full"
              : props?.typepop === "txnHistorypopup" ||
                  props?.similarTxnType === "similarTxn"
                ? " h-full flex-1"
                : "h-screen"
          }`}
          id=" benetxnmain "
        >
          <div
            className={`transactionHistoryPop_topDiv ${
              props?.typepop === "transactionHistorypopup" ||
              props?.typepop === "RejectAllTransactionPopup"
                ? "flex flex-row justify-between items-center p-5"
                : "hidden"
            } ${
              (props?.typepop === "transactionHistorypopup" &&
                !props?.OwnerDetail) ||
              props?.typepop === "RejectAllTransactionPopup"
                ? "hidden Qmd:flex"
                : "none"
            }`}
          >
            <div className="flex flex-col space-y-1">
              {props?.typepop === "transactionHistorypopup" && (
                <p className="text-font-md text-text-primary font-sans font-semibold">
                  {props?.popup ?? "Transaction history"}
                </p>
              )}

              {props?.typepop === "RejectAllTransactionPopup" && (
                <p className="text-font-md text-text-primary font-sans font-semibold">
                  Associated transactions found
                </p>
              )}

              <p className="text-font-xs text-text-secondary font-sans font-normal">
                {props?.typepop === "transactionHistorypopup" &&
                props?.popup !== "Confidential transaction"
                  ? "All transactions related to the beneficiary are listed below."
                  : props?.typepop === "transactionHistorypopup" &&
                      props?.popup === "Confidential transaction"
                    ? "All confidential transactions related to the beneficiary are listed below."
                    : props?.typepop === "RejectAllTransactionPopup" &&
                        props?.flowType ===
                          "decline_account_require_approval_flow"
                      ? "The following transactions are linked and need to be rejected before archiving this account."
                      : props?.typepop === "RejectAllTransactionPopup" &&
                          props?.flowType === "ArchiveAccount"
                        ? "The following transactions are linked and need to be rejected before archiving this account."
                        : "The following transactions are linked and need to be rejected before rejecting this account."}
              </p>
            </div>

            <IconRoundButton
              enabledBgColor={"var(--primary-nav-act)"}
              isLoading={loading}
              handleFunction={() => {
                setTimeout(() => {
                  if (props?.typepop === "transactionHistorypopup") {
                    props?.onClose();
                  } else if (props?.typepop === "RejectAllTransactionPopup") {
                    props?.closeRejectAllTxn();
                  }
                }, IntervalConfiguration.intervalSemiMid);
              }}
              title="Close"
              icon={ICONS?.CLOSE}
              hoverOption="white"
              btnType={"button"}
              isDisabled={false}
            />
          </div>
          <div className="w-width-full z-z-index-overlay">
            {props?.typepop === "transactionHistorypopup" ||
            props?.typepop === "txnHistorypopup" ||
            props?.similarTxnType === "similarTxn" ||
            props?.typepop === "RejectAllTransactionPopup" ||
            props?.typepop === "BeneAccRejectTxn" ? (
              ""
            ) : (
              <>
                <div className="Qsmd:h-navbar-breadcrumb-height bg-primary-nav"></div>
              </>
            )}
            <TopNavComponent
              loading={loading}
              topNavHeader={totalBalanceAmount}
              topNavSubText={"Total amount"}
              topNavCtaBtn1Needed={isLabelClicked}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText:
                        Array.isArray(labelTransactions) &&
                        labelTransactions.length > 0
                          ? "Clear"
                          : "Cancel",
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: () => {
                        if (labelTransactions?.length > 0) {
                          setLabelTransactions([]);
                        } else {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption: "white",
                    }
                  : undefined
              }
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
              topNavCtaBtn2Needed={isLabelClicked}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign Labels",
                      btnType: "button",
                      enabledBgColor: labelTransactions?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (!labelTransactions.length) return;
                        setIsLabelPopupOpen(true);
                      },
                      enabledTextColor: labelTransactions?.length
                        ? "var(--primary-bg)"
                        : "var(--text-primary)",
                      isDisabled: !labelTransactions?.length,
                      inActiveVariantNeeded: true,
                      hoverOption: labelTransactions?.length
                        ? "black"
                        : "white",
                    }
                  : undefined
              }
              isSelectionView={isLabelClicked}
              selectionText={`Transactions selected - ${selectedCount || GlobalConfiguration.lengthCheckZero}`}
              BottomSubText={
                isLabelClicked
                  ? "Select transactions to apply labels. These labels will be used to generate statistics for the associated transactions."
                  : undefined
              }
              BottomSubTextVaraint="primary"
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: `Select up to ${Number(selectedValue)}`,
                      enabledBgColor: `${
                        isAllSelected
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)"
                      }`,
                      isDisabled:
                        loading ||
                        selectableTransactions?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                      handleFunction: (e) => {
                        if (loading) return;
                        e.stopPropagation();
                        if (selectableTransactions?.length) {
                          handleSelectAll();
                        }
                      },
                      iconToBeAlign: "left",
                      enabledTextColor: "var(--text-primary)",
                      icon: isAllSelected
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                      fullWidthRequired: false,
                      hoverOption: `${labelTransactions?.length ? "black" : "white"}`,
                    }
                  : undefined
              }
              isToggleNeeded={true}
              toggleProps={
                !isLabelClicked
                  ? {
                      state: toggle,
                      title: toggle ? "Grid View" : "List View",
                      isDisabled: false,
                      handleClick: () => {
                        handleToggle(!toggle);
                      },
                    }
                  : undefined
              }
              filteredSearchProps={{
                isSortDisabled: loading,
                isFilterDisabled: loading,
                loadingData: loadingData,
                loading: loading,
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: loading,
                onSearchInput: (val) => setSearchUserTextDebounce(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search beneficiary transaction",
                filterPlaceholder: "transaction details",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: txnAddDetails,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setTxnAddDetails(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Beneficiary account",
                    short_name: "Bene. Acc",
                    isMulti: false,
                    value: selectedBeneAccId,
                    displayValue:
                      (props.typepop === "transactionHistorypopup" ||
                        props.typepop === "txnHistorypopup" ||
                        props?.similarTxnType === "similarTxn") &&
                      props.label === "categoryName"
                        ? accountNameValue
                            .toLowerCase()
                            .split(" ")
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1),
                            )
                            .join(" ")
                        : props?.typepop === "transactionHistorypopup" ||
                            props.typepop === "txnHistorypopup" ||
                            props?.similarTxnType === "similarTxn" ||
                            accountName
                              ?.toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")
                          ? accountName
                              ?.toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")
                          : accountNameValue
                              ?.toLowerCase()
                              .split(" ")
                              .map(
                                (word) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" "),
                    setValue: (val) => {
                      handleSubmit("beneAcc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setSelectedBeneAccId(val);
                      if (!val) {
                        handleSubmit("beneAccName", "");
                      }
                    },
                    setDisplayValue: (val) => {
                      handleSubmit("beneAccName", val);
                      setAccountName(val);
                      setAccountNameValue(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading
                      ? true
                      : props?.typepop === "txnHistorypopup" &&
                          props?.OwnerDetail
                        ? false
                        : props?.type === "bene_account_detail_modal" ||
                            props?.typepop === "BeneAccRejectTxn"
                          ? true
                          : (props.typepop === "txnHistorypopup" ||
                                props?.similarTxnType === "similarTxn") &&
                              selectedBeneAccId
                            ? true
                            : !(
                                (props.label === "categoryName" &&
                                  props.typepop ===
                                    "transactionHistorypopup") ||
                                ((props?.typepop !==
                                  "transactionHistorypopup" ||
                                  props?.OwnerDetail) &&
                                  props?.typepop !==
                                    "RejectAllTransactionPopup") ||
                                props?.typepop === "BeneAccRejectTxn"
                              ),
                  },
                  {
                    name: "Owner account",
                    short_name: "Own. Acc",
                    isMulti: false,
                    value: selectedOwnerAccId,
                    displayValue: standardAccountNumberFormat(
                      accountNumber,
                      true,
                    ),
                    setValue: (val) => {
                      handleSubmit("sourceAcc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setSelectedOwnerAccId(val);
                      if (!val) {
                        handleSubmit("sourceAccName", "");
                      }
                    },
                    setDisplayValue: (val) => {
                      handleSubmit("sourceAccName", val);
                      setAccountNumber(val);
                    },
                    valueType: "string",
                    isDropdown: true,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.owner_account_id
                        ? true
                        : loading
                          ? true
                          : props?.OwnerDetail
                            ? true
                            : false,
                  },
                  {
                    name: "Category",
                    valueType: "string",
                    short_name: "Cat",
                    isMulti: false,
                    value: currentCategory,
                    displayValue: displayCategory,
                    setValue: (val) => {
                      const c =
                        categories.filter((x) => x.id === val)[0]?.name ?? "";
                      setDisplayCategory(c);
                      handleSubmit("dispCategory", c);
                      handleSubmit("category", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setCurrentCategory(val);
                    },
                    isDropdown: true,
                    isDisabled: loading
                      ? true
                      : props?.typepop === "txnHistorypopup" &&
                          props?.label?.label === "categoryName"
                        ? true
                        : props?.typepop === "txnHistorypopup" &&
                            props?.label?.label === "accountName"
                          ? false
                          : props?.popup === "Transaction history" &&
                              currentCategory !== ""
                            ? true
                            : (props?.typepop === "transactionHistorypopup" &&
                                  props.label !== "categoryName") ||
                                (props?.typepop === "transactionHistorypopup" &&
                                  props?.bene_account_confidential === "Y")
                              ? false
                              : props?.OwnerDetail
                                ? false
                                : props?.typepop === "transactionHistorypopup"
                                  ? true
                                  : false,
                  },
                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: labelsFilter,
                    setValue: (val) => {
                      handleSubmit("label", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setFilterLabels(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading,
                  },
                  {
                    name: "Amount",
                    short_name: "Amt - INR",
                    isMulti: false,
                    value: txnAmountFilter,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("amount", val);
                      setTxnAmountFilter(val);
                    },
                    displayValue: FormatAmount({ price: txnAmountFilter }),
                    isDropdown: false,
                    isDisabled:
                      props?.similarTxnType === "similarTxn" &&
                      props?.queryParams?.amount
                        ? true
                        : loading,
                    valueType: "number",
                  },
                ],
                filters: [
                  {
                    name: "Approval status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: currentStatus === undefined ? "" : currentStatus,
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      props?.type === "bene_account_detail_modal"
                        ? true
                        : props?.typepop === "BeneAccRejectTxn"
                          ? true
                          : currentStatusDistribution?.length >
                              GlobalConfiguration.lengthCheckZero
                            ? true
                            : false,
                    options:
                      services?.includes("CBeneficiaryTxn") &&
                      !services?.includes("ABeneficiaryTxn")
                        ? ["approved", "pending", "rejected", "abandoned"]
                        : [
                            "approved",
                            "require approval",
                            "pending",
                            "rejected",
                            "abandoned",
                          ],
                    statusPop: true,
                    handleChange: handleStatus,
                  },
                  {
                    name: "Distribution status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: getDisplayDistributionStatus(
                      currentStatusDistribution,
                    ),
                    dropdownPlaceHolder: "Select status",
                    isDisabled:
                      props?.type === "bene_account_detail_modal"
                        ? true
                        : currentStatus?.length >
                            GlobalConfiguration.lengthCheckZero
                          ? true
                          : false,
                    options: [
                      "distribution complete",
                      "distribution created",
                      "distribution approved",
                      "awaiting funds",
                      "distribution initiated",
                      "distribution pending",
                      "distribution rejected",
                      "distribution failed",
                      "distribution reversal",
                      "distribution denied",

                      "distribution abandoned",
                    ],
                    statusPop: true,
                    handleChange: handleStatus1,
                  },
                  {
                    name: "Payment method",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["NEFT", "RTGS"],
                    searchPlaceholder: "Search",
                    dropdownPlaceHolder: "Select type",
                    value: isPaymentMethod,
                    isDisabled:
                      (props?.similarTxnType === "similarTxn" &&
                        props?.queryParams?.payment_method) ||
                      currentStatus === "require approval",
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("paymentmethod", val);
                      handlePaymentMethod(val);
                    },
                    dropdownType: "PaymentMethod",
                  },
                  {
                    name: "Show/hide confidential transactions",
                    filterType: "dropdown",
                    variant: "single",
                    isSearch: false,
                    options: ["Show only confidential", "Hide confidential"],
                    searchPlaceholder: "Search",
                    isDisabled:
                      (props?.similarTxnType === "similarTxn" &&
                        props?.queryParams?.confidential_transaction ===
                          "Show only confidential") ||
                      ((props?.typepop === "transactionHistorypopup" ||
                        props?.typepop === "txnHistorypopup") &&
                        props?.bene_account_confidential?.length > 0),
                    dropdownPlaceHolder: "Default (all transactions)",
                    value: isConfidentialMethod,
                    handleChange: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("confidential", val);
                      handleConfidentialMethod(val);
                    },
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value: startDateFilter && endDateFilter,
                    isDisabled: currentStatus === "require approval",
                    startDate: startDateFilter
                      ? new Date(
                          startDateFilter *
                            IntervalConfiguration.intervalMedium,
                        )
                      : startDateFilter,
                    endDate: endDateFilter
                      ? new Date(
                          endDateFilter * IntervalConfiguration.intervalMedium,
                        )
                      : endDateFilter,
                    handleChange: (date) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("date", date);
                      handleFilterDateRange(date);
                    },
                  },
                ],
                isSearchClearAllDisabled:
                  props?.popup === "Confidential transaction" &&
                  selectedBeneAccId !== ""
                    ? !(
                        currentCategory ||
                        txnAmountFilter ||
                        selectedOwnerAccId ||
                        txnAddDetails !== "" ||
                        labelsFilter?.length !==
                          GlobalConfiguration.lengthCheckZero
                      )
                    : props?.typepop === "txnHistorypopup"
                      ? !(
                          txnAddDetails !== "" ||
                          (selectedBeneAccId &&
                            selectedBeneAccId !== props?.bene_account_id) ||
                          (currentCategory &&
                            currentCategory !== (props?.category || "")) ||
                          txnAmountFilter ||
                          selectedOwnerAccId ||
                          labelsFilter?.length !==
                            GlobalConfiguration.lengthCheckZero
                        )
                      : props?.typepop === "txnHistorypopup" &&
                          props?.label?.label === "categoryName"
                        ? !(
                            selectedBeneAccId ||
                            txnAmountFilter ||
                            selectedOwnerAccId ||
                            txnAddDetails !== "" ||
                            labelsFilter?.length !==
                              GlobalConfiguration.lengthCheckZero
                          )
                        : props?.popup === "Transaction history" &&
                            currentCategory !== "" &&
                            !(
                              selectedBeneAccId ||
                              txnAmountFilter ||
                              selectedOwnerAccId ||
                              txnAddDetails !== "" ||
                              labelsFilter?.length !==
                                GlobalConfiguration.lengthCheckZero
                            )
                          ? true
                          : props?.similarTxnType === "similarTxn" &&
                              (selectedBeneAccId ||
                                txnAmountFilter ||
                                selectedOwnerAccId) &&
                              !(
                                txnAddDetails !== "" ||
                                labelsFilter?.length !==
                                  GlobalConfiguration.lengthCheckZero ||
                                currentCategory !== ""
                              )
                            ? true
                            : (props?.type === "bene_account_detail_modal" &&
                                  props?.similarTxnType !== "similarTxn" &&
                                  selectedBeneAccId) ||
                                (props?.typepop === "BeneAccRejectTxn" &&
                                  selectedBeneAccId &&
                                  !(
                                    currentCategory ||
                                    txnAmountFilter ||
                                    selectedOwnerAccId ||
                                    txnAddDetails !== "" ||
                                    labelsFilter?.length !==
                                      GlobalConfiguration.lengthCheckZero
                                  ))
                              ? true
                              : false,
                isFilterClearAllDisabled:
                  (props?.similarTxnType === "similarTxn" &&
                    props?.queryParams?.payment_method) ||
                  (props?.similarTxnType === "similarTxn" &&
                    props?.queryParams?.confidential_transaction ===
                      "Show only confidential")
                    ? true
                    : props?.typepop === "BeneAccRejectTxn" &&
                        (currentStatus?.length >
                          GlobalConfiguration.lengthCheckZero ||
                          currentStatusDistribution?.length >
                            GlobalConfiguration.lengthCheckZero) &&
                        !(
                          isConfidentialMethod ||
                          isPaymentMethod ||
                          (startDateFilter && endDateFilter)
                        )
                      ? true
                      : props?.type === "bene_account_detail_modal"
                        ? true
                        : !(
                            (isConfidentialMethod && !isConfPopup) ||
                            isPaymentMethod ||
                            (startDateFilter && endDateFilter) ||
                            currentStatus?.length >
                              GlobalConfiguration.lengthCheckZero ||
                            currentStatusDistribution?.length >
                              GlobalConfiguration.lengthCheckZero
                          ),
                inputData: inputData,
                active: active,
                setActive: setActive,

                setLoading: (e) => {},
                isShowFilter: true,
                isShowSortBy: false,
              }}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      isDisabled:
                        loading ||
                        props?.typepop === "BeneAccRejectTxn" ||
                        !accumulatedData?.length ||
                        (props?.similarTxnType === "similarTxn" &&
                          props?.queryParams?.confidential_transaction ===
                            "Show only confidential") ||
                        props?.type === "bene_account_detail_modal" ||
                        props.typepop === "transactionHistorypopup" ||
                        props.typepop === "txnHistorypopup" ||
                        props?.similarTxnType === "similarTxn" ||
                        props?.typepop === "RejectAllTransactionPopup",
                      enabledBgColor: "var(--primary-bg)",
                      handleFunction: () => {
                        if (loading) return;
                        if (!accumulatedData?.length) return;
                        if (
                          props?.type === "bene_account_detail_modal" ||
                          props.typepop === "transactionHistorypopup" ||
                          props.typepop === "txnHistorypopup" ||
                          props?.similarTxnType === "similarTxn" ||
                          props?.typepop === "RejectAllTransactionPopup" ||
                          props?.typepop === "BeneAccRejectTxn"
                        ) {
                          actionRestricted();
                        } else {
                          if (
                            services?.includes("ALabel") &&
                            services?.includes("RLabel")
                          ) {
                            setisLabelClicked((prev) => {
                              if (prev) setLabelTransactions([]);
                              return !prev;
                            });
                          } else {
                            navigate("/feature_not_assigned", {
                              state: {
                                unavailableService: "ALabel,RLabel",
                              },
                            });
                          }
                        }
                      },
                      hoverOption: "white",
                      disabledBgColor: "var(--primary-bg)",
                      title:
                        "Labels will be used to generate statistics for the associated transactions.",
                    }
                  : undefined
              }
            />
          </div>

          {showInnerSearchBar && (
            <div className="absolute bg-PopUp-BackDrop bg-opacity-light-opacity pointer-events-none w-full h-full z-z-index-header"></div>
          )}
          <div
            ref={scrollContainerRef}
            id="benetxnViewallScrollContainer"
            className={`overflow-hidden relative ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "mb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:mb-[var(--pagination-height)] mb-topnav-bottom-height"
                  : "mb-[var(--pagination-height)]"
            }`}
            style={{
              scrollPaddingTop: "var(--padding-md)",
              scrollPaddingBottom: "var(--padding-md)",
              pointerEvents: showInnerSearchBar ? "none" : "",
              flex: "1",
              paddingTop:
                !showSearchBar &&
                isFilterApplied &&
                !accumulatedData.length &&
                props?.typepop === "transactionHistorypopup" &&
                !toggle
                  ? "var(--padding-md)"
                  : isFilterApplied &&
                      !accumulatedData.length &&
                      props?.typepop === "RejectAllTransactionPopup"
                    ? "var(--padding-md)"
                    : "",
            }}
          >
            {loading ? (
              <div className="loader-container m-auto justify-center items-center flex h-full">
                <Loader />
              </div>
            ) : accumulatedData?.length ? (
              !toggle ? (
                <div
                  className="flex flex-col min-h-height-base flex-1 items-center w-full h-height-full z-z-index-base overflow-y-auto scroll-py-top_md"
                  ref={filterRef}
                >
                  <BeneficiaryTransactionGridView
                    data={accumulatedData}
                    filterRef={scrollContainerRef}
                    typepop={props?.typepop}
                    type={props?.type}
                    onClose={props?.onClose}
                    currentStatus={currentStatus}
                    isLabelClicked={isLabelClicked}
                    labelTransactions={labelTransactions}
                    showInnerSearchBar={showInnerSearchBar}
                    openTransHistory={props?.openTransHistory}
                    similarTxn={props?.similarTxnType}
                    handleLabelSelect={handleLabelTransactionSelect}
                  />
                  <div
                    className={`h-navbar-height ${(props?.typepop === "RejectAllTransactionPopup" || props?.typepop === "transactionHistorypopup") && "mb-margin-bottom-pop-up"}`}
                  ></div>
                </div>
              ) : (
                <div
                  ref={filterRef}
                  className="flex flex-col overflow-y-auto h-height-full scroll-py-top_md"
                >
                  <BeneficiaryTransactionListView
                    data={accumulatedData}
                    filterRef={scrollContainerRef}
                    currentStatus={currentStatus}
                    type={props?.type}
                    typepop={props?.typepop}
                    onClose={props?.onClose}
                    isLabelClicked={isLabelClicked}
                    labelTransactions={labelTransactions}
                    openTransHistory={props?.openTransHistory}
                    similarTxn={props?.similarTxnType}
                    handleLabelSelect={handleLabelTransactionSelect}
                  />
                </div>
              )
            ) : (
              <div className="flex items-center justify-center overflow-y-auto h-height-full">
                <div
                  className="flex flex-col items-center justify-center"
                  style={{
                    margin:
                      props?.typepop !== "transactionHistorypopup" && "auto",
                    paddingBottom: showSearchBar && "var(--padding-xl)",
                  }}
                >
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="No accounts found"
                    className="w-graphic-width-md h-graphic-rectangle-height-md"
                  />
                  <p className="text-font-sm text-text-primary text-center font-sans font-normal my-margin-sm">
                    No data found.
                  </p>
                  {clearParameterVisibility && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={handleClearParams}
                      enabledTextColor="var(--text-primary)"
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default BeneficiaryTransactionViewall;
